import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../config/supabase';

const RestaurantAdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Sign in with Supabase Auth
      const { data: authData, error: authError } = await supabase.auth.signInWithPassword({
        email: credentials.email,
        password: credentials.password
      });

      if (authError) throw authError;

      console.log('✅ Auth successful, user ID:', authData.user.id);
      console.log('📧 Email:', authData.user.email);

      // Check if user is restaurant staff
      const { data: staffData, error: staffError } = await supabase
        .from('restaurant_staff')
        .select('*')
        .eq('user_id', authData.user.id)
        .eq('is_active', true)
        .single();

      console.log('🔍 Staff query result:', staffData);
      console.log('❌ Staff query error:', staffError);

      if (staffError || !staffData) {
        // User exists but is not restaurant staff
        console.log('⛔ User not found in restaurant_staff or not active');
        await supabase.auth.signOut();
        throw new Error('Access denied. You are not authorized as restaurant staff.');
      }

      console.log('✅ Staff verified, role:', staffData.role);

      // Success - redirect based on role
      if (staffData.role === 'kitchen') {
        navigate('/kitchen-dashboard');
      } else {
        navigate('/restaurant-admin');
      }
      
    } catch (error) {
      console.error('❌ Login error:', error);
      setError(error.message || 'Invalid credentials or access denied');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-wrapper">
        {/* Logo */}
        <div className="logo-container" style={{textAlign: 'center', marginBottom: '2rem'}}>
          <img src="/images/IBVlogo.png" alt="IBV Wealth Club" style={{maxWidth: '150px', height: 'auto'}} />
        </div>

        <div className="card">
          <h2 className="section-title text-center" style={{ marginBottom: '0.5rem' }}>
            Restaurant Admin
          </h2>
          <p style={{ 
            textAlign: 'center', 
            color: 'var(--color-gray-dark)', 
            marginBottom: '1.5rem',
            fontSize: 'var(--font-md)'
          }}>
            Privé Lounge & Bakery
          </p>

          {error && (
            <div className="alert alert-error" style={{ marginBottom: '1rem' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {error && (
              <div style={{
                padding: '1rem',
                marginBottom: '1.5rem',
                background: 'rgba(255, 0, 0, 0.1)',
                border: '1px solid #ff0000',
                borderRadius: '4px',
                color: '#ff0000',
                textAlign: 'center'
              }}>
                {error}
              </div>
            )}

            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input
                type="email"
                name="email"
                className="form-input"
                value={credentials.email}
                onChange={handleChange}
                required
                placeholder="admin@privelounge.com"
                autoComplete="email"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-input"
                  value={credentials.password}
                  onChange={handleChange}
                  required
                  placeholder="Enter your password"
                  autoComplete="current-password"
                  style={{ paddingRight: '45px' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1.2rem',
                    padding: '5px',
                    color: 'var(--color-gray-dark)'
                  }}
                >
                  {showPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>

          <div style={{ 
            marginTop: '1.5rem', 
            paddingTop: '1.5rem',
            borderTop: '1px solid var(--color-border)',
            textAlign: 'center'
          }}>
            <p style={{ 
              color: 'var(--color-gray-dark)', 
              fontSize: 'var(--font-sm)'
            }}>
              Restaurant staff only. Contact your manager for access.
            </p>
          </div>
        </div>

        {/* Back Button */}
        <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
          <button
            onClick={() => navigate('/prive-lounge')}
            className="btn btn-secondary"
            style={{ minWidth: '200px' }}
          >
            ← Back to Privé Lounge
          </button>
        </div>
      </div>
    </div>
  );
};

export default RestaurantAdminLogin;
